angular.module('amateurPool')
  .component('onswAmateurTagList', {
    bindings: { amateur: '<' },
    template: `<div class="box">
        <ul><li ng-repeat="tag in $ctrl.amateur.topics"><a ng-href="#/amateurs/search?filter-search.trigger=sedcard&filter-search.facets.topic_list={{ tag }}" >{{ 'models.AmateurProfile.topic_list_attributes.'+tag | translate }}</a></ul>
      </div>`
  });
